<template>
  <!-- 主蝥业务 -->
  <div class="business">
    <basepanel>
    <h2 class="bus-title">主营业务</h2>
    <div class="outer-box">
      <lists :categoryId="id" :prePath="prePath"></lists>
    </div>
    </basepanel>
  </div>
</template>

<script>
import lists from "../components/Lists";
import basepanel from "../components/BasePanel";
export default {
  name: "business",
  components: { lists, basepanel },
  data() {
    return {
      id: this.$map.buscategoryId,
      prePath:"business"
    };
  },
};
</script>

<style scoped lang="less">
.bus-title{
  opacity:0
}
@media screen and (min-width: 0px) and (max-width:1200px) {
  .bus-title{
    opacity:1;
    // font-weight:bold;
    text-align:center;
    padding:10px;
    box-sizing:border-box;
        font-size: 18px;
    font-weight: bold;
        margin-top: 3vh;
    // font-family:"Microsoft YaHei";
  }

}

</style>
